module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.animotion ? 'fixed' : '',
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_subscribe == 0),
      expression: "is_subscribe == 0"
    }],
    staticClass: "top-prompt",
    on: {
      "click": _vm.showQRcode
    }
  }, [_c('i', {
    staticClass: "pull-left ionicons ion-ios-information mr10"
  }), _vm._v(" "), (!_vm.is_vietnam) ? [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("您还没关注公众号，快来关注我吧！")]), _vm._v(" "), _c('button', [_vm._v("关注")])] : [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Bạn không quan tâm đến công chúng, hãy đến và theo dõi tôi!")]), _vm._v(" "), _c('button', [_vm._v("Sự quan tâm")])]], 2), _vm._v(" "), _c('router-view', {
    class: {
      'none-subscribe': _vm.is_subscribe == 0
    },
    attrs: {
      "foot_type": _vm.foot_type,
      "is_wifi": _vm.is_wifi
    }
  }), _vm._v(" "), (_vm.wrap) ? _c('div', {
    staticClass: "wrap",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "QR-code"
  }, [_c('i', {
    staticClass: "close ionicons ion-ios-close-outline",
    on: {
      "click": _vm.showQRcode
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": _vm.img_path,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("长按二维码，关注我们")])])]) : _vm._e(), _vm._v(" "), (_vm.showkefu) ? _c('div', {
    ref: "kefu",
    staticClass: "h-navi",
    style: ([{
      'bottom': _vm.bottomValue + 'px'
    }, {
      'right': _vm.rightValue + 'px'
    }]),
    attrs: {
      "i": "navigation"
    },
    on: {
      "touchmove": _vm.touchmove,
      "touchstart": _vm.touchstart,
      "touchend": _vm.touchend
    }
  }, [(!_vm.is_vietnam) ? _c('a', {
    staticClass: "h-service m-size",
    on: {
      "click": function($event) {
        return _vm.toKefu()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_vietnam) ? _c('a', {
    staticClass: "h-service m-size",
    staticStyle: {
      "background-image": "url(/static/images/vietnam/hover_service@3x.png)"
    },
    on: {
      "click": function($event) {
        return _vm.toKefu()
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_alert),
      expression: "show_alert"
    }],
    staticClass: "base-props-box"
  }, [_c('div', {
    staticClass: "props",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-a",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "middle-center"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("检测到您还未完善实名信息，为了更好的为您提供更多服务，请移步完善！")]), _vm._v(" "), _c('div', {
    staticClass: "div-btns clearfix"
  }, [_c('a', {
    staticClass: "pull-left",
    on: {
      "click": function($event) {
        _vm.show_alert = false
      }
    }
  }, [_vm._v("下次再说")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toInfo()
      }
    }
  }, [_vm._v("前往完善")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_prop),
      expression: "show_prop"
    }],
    staticClass: "base-props-box"
  }, [_c('div', {
    staticClass: "props"
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-a"
  }, [_c('div', {
    staticClass: "middle-center"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("此常住地无需与身份证地址相同，请选择您从事商业活动和日常生活所在地，如有变更，可在个人设置中修改")]), _vm._v(" "), _c('div', {
    staticClass: "div-btns clearfix"
  }, [_c('a', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toAddress()
      }
    }
  }, [_vm._v("前往设置")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_esign),
      expression: "show_esign"
    }],
    staticClass: "base-props-box"
  }, [_c('div', {
    staticClass: "props"
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-a"
  }, [_c('div', {
    staticClass: "middle-center"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("恭喜您成为生命说加盟商，为了保护您的权益，快去签署《加盟商合同》吧！")]), _vm._v(" "), _c('div', {
    staticClass: "div-btns clearfix"
  }, [_c('a', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toUrl('/contract/index')
      }
    }
  }, [_vm._v("去签署")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bind_superior),
      expression: "bind_superior"
    }],
    staticClass: "alert-box"
  }, [_c('div', {
    staticClass: "alert-mk"
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-cont"
  }, [_c('div', {
    staticClass: "cont-title"
  }, [_vm._v("提醒信息")]), _vm._v(" "), _c('div', {
    staticClass: "cont-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "cont-phone"
  }, [_vm._v("绑定推荐人，可享更多服务")]), _vm._v(" "), _c('div', {
    staticClass: "alert-btn-group"
  }, [_c('div', {
    staticClass: "alert-btn-cancel",
    on: {
      "click": function($event) {
        _vm.bind_superior = false
      }
    }
  }, [_vm._v("稍候绑定")]), _vm._v(" "), _c('div', {
    staticClass: "alert-btn-confirm",
    on: {
      "click": _vm.handelBindSuperior
    }
  }, [_vm._v("立即绑定")])])])]), _vm._v(" "), (_vm.advertise.lists.length) ? _c('div', {
    staticClass: "middle-eject"
  }, [_c('div', {
    staticClass: "back"
  }), _vm._v(" "), _c('div', {
    staticClass: "advertise"
  }, [_c('div', {
    staticClass: "close-adver",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeBack()
      }
    }
  }, [_vm._v("跳过")]), _vm._v(" "), _c('div', {
    staticClass: "adver-content",
    style: (("background-image:url(" + (_vm.advertise.back.cover) + ");")),
    on: {
      "click": function($event) {
        return _vm.goOutsideUrl(_vm.advertise.back)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.giftGoods.length > 0) ? _c('div', {
    staticClass: "remind-box"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "del-icon",
    on: {
      "click": function($event) {
        _vm.giftGoods = []
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "remind-title"
  }, [_vm._v("赠品到期提醒")]), _vm._v(" "), _c('div', {
    staticClass: "remind-desc"
  }, [_vm._v("以下云仓中赠品请尽快自提，超时未自提将自动扣除：")]), _vm._v(" "), _c('div', {
    staticClass: "goods-box"
  }, _vm._l((_vm.giftGoods), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "goods-item"
    }, [_c('div', {
      staticClass: "goods"
    }, [_c('div', {
      staticClass: "cover",
      style: ({
        'background-image': 'url(' + item.cover + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "num"
    }, [_vm._v("x " + _vm._s(item.gift_num))]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v("失效时间:" + _vm._s(item.expires_time))])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "remind-btn",
    on: {
      "click": function($event) {
        _vm.giftGoods = [];
        _vm.toUrl('/distribution/dispatch/index')
      }
    }
  }, [_vm._v("立即自提")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', [_vm._v("生命说商城")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22aaa510!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2241
// module chunks = 353